<template>
  <div class="updatSeting">
    <el-row>
      <div class="model-header setting">
        <h2>Config Home Banner</h2>
        <el-button @click="logModel.dialogVisibleLog = true" size="small" type="info" class="btn-create">Xem log</el-button>
      </div>
    </el-row>
    <el-row :gutter="10">
      <div class="model-content">
        <el-row :gutter="20">
          <el-col :span="12">
            <div class="line">
              <el-upload
                class="course-uploader"
                :action="upload.url_fit_fix"
                :headers="upload.headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-progress="handleAvatarProcess"
                :before-upload="beforeAvatarUpload">
                <img v-if="image_path" :src="image_path" class="courseSettig">
                <div slot="tip" class="el-upload__tip">
                  <i class="fas fa-spinner fa-spin" v-if="upload.uploadProcess"></i>
                  Ảnh banner chính có kích thước 1440 * 400
                </div>
              </el-upload>
              <div>
                <p style="padding-left: 30px;">{{ image }}</p>
                <p style="padding-left: 30px;" v-if="image">sm_{{ image }}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="line">
              <el-upload
                class="course-uploader"
                :action="upload.url_fit_fix2"
                :headers="upload.headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-progress="handleAvatarProcess"
                :before-upload="beforeAvatarUpload">
                <img v-if="image_path" :src="image_path" class="courseSettig">
                <div slot="tip" class="el-upload__tip">
                  <i class="fas fa-spinner fa-spin" v-if="upload.uploadProcess"></i>
                  Ảnh banner phụ có kích thước 1140 * 400
                </div>
              </el-upload>
              <div>
                <p style="padding-left: 30px;">{{ image }}</p>
                <p style="padding-left: 30px;" v-if="image">sm_{{ image }}</p>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <h4>Banner chính</h4>
             <div v-for="(image_p) in modelData.list_banner" :key="image_p.key">
              <div class="line">
                <input type="text" placeholder="Ảnh" v-model="image_p.image">
                <img :src="getImage(image_p.image)" alt="" class="image-preview">
                <el-button @click.prevent="removeImage1(image_p)" size="small">Xóa</el-button>
              </div>
            </div>
            <el-button class="huhu" type="default" size="mini" @click="addImage1()">Thêm ảnh</el-button>
          </el-col>
          <el-col :span="12">
            <h4>Banner phụ</h4>
            <div class="line">
              <input type="text" placeholder="Ảnh" v-model="modelData.promotion_image">
              <img :src="getImage(modelData.promotion_image)" alt="" class="image-preview">
            </div>

            <h4>Đối tác</h4>

            <div class="line">
              <el-input
                v-model="modelData.title_partner"
                placeholder="ĐƠN VỊ PHỐI HỢP ĐÀO TẠO & CẤP BẰNG"
                class="input-seach">
              </el-input>
            </div>

            <div class="line">
              <el-upload
                class="course-uploader"
                :action="upload.url_fit_fix3"
                :headers="upload.headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-progress="handleAvatarProcess"
                :before-upload="beforeAvatarUpload">
                <img v-if="image_path" :src="image_path" class="courseSettig">
                <div slot="tip" class="el-upload__tip">
                  <i class="fas fa-spinner fa-spin" v-if="upload.uploadProcess"></i>
                  Ảnh logo đối tác kích thước 500 * 500
                </div>
              </el-upload>
              <div>
                <p style="padding-left: 30px;">{{ image }}</p>
                <p style="padding-left: 30px;" v-if="image">sm_{{ image }}</p>
              </div>
            </div>

            <div v-for="(image_p) in modelData.list_partner" :key="image_p.key">
              <div class="line">
                <input v-model="image_p.image" placeholder="Ảnh" />
                <img :src="getImage(image_p.image)" alt="" class="image-preview">
                <el-button @click.prevent="removeImage2(image_p)" size="small">Xóa</el-button>
              </div>
            </div>
            <el-button class="huhu" type="default" size="mini" @click="addImage2()">Thêm logo</el-button>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <h4>Tài nguyên - tiện tích cho sinh viên</h4>

            <div class="line">
              <el-upload
                class="course-uploader"
                :action="upload.url_fit_fix3"
                :headers="upload.headers"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :on-progress="handleAvatarProcess"
                :before-upload="beforeAvatarUpload">
                <img v-if="image_path" :src="image_path" class="courseSettig">
                <div slot="tip" class="el-upload__tip">
                  <i class="fas fa-spinner fa-spin" v-if="upload.uploadProcess"></i>
                  Ảnh logo đối tác kích thước 500 * 500
                </div>
              </el-upload>
              <div>
                <p style="padding-left: 30px;">{{ image }}</p>
                <p style="padding-left: 30px;" v-if="image">sm_{{ image }}</p>
              </div>
            </div>

            <div v-for="(image_p) in modelData.list_resources" :key="image_p.key">
              <div class="line">
                <input v-model="image_p.link" placeholder="Link" />
                <input v-model="image_p.title_1" placeholder="Tiêu đề 1" />
                <input v-model="image_p.title_2" placeholder="Tiêu đề 2" />
                <el-color-picker v-model="image_p.color_1"></el-color-picker>
                <img :src="image_p.image" alt="" class="image-preview">
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-row>
    <div style="padding-top: 20px">
      <el-button
        :disable="!canSubmit"
        :loading="!canSubmit"
        type="warning"
        size="small"
        @click="updateModelHomeMenu()">Cập nhật</el-button>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="'Lịch sử thay đổi'"
      :visible.sync="logModel.dialogVisibleLog"
      width="45%">
      <div class="log-class-user" v-if="logModel.logs">
        <div
          class="item"
          :key="index_1"
          v-for="(item, index_1) in logModel.logs">
          <strong>{{ item.user_request_name }} - {{ item.user_request_email }}</strong> đã cập nhật cấu hình
          <div>
            <span class="time">{{ item.time }}</span>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="logModel.dialogVisibleLog = false" size="small">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import tinymce from 'vue-tinymce-editor'
import ls from 'local-storage'
export default {
  name: 'ConfigHomeBanner',
  components: {
    tinymce
  },
  metaInfo () {
    return {
      title: 'Config Home'
    }
  },
  data () {
    return {
      canSubmit: true,
      logModel: {
        dialogVisibleLog: false,
        activeName: 'first',
        logs: {}
      },
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link image media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      modelData: {

      },
      modelData_ID: 0,
      image: '',
      image_path: '',
      upload: {
        uploadProcess: false,
        url: process.env.API_URI + 'configs/upload',
        url_not_resize: process.env.API_URI + 'configs/upload-not-resize',
        url_fit_fix: process.env.API_URI + 'configs/upload-fit-fix/1440/400/720/200',
        url_fit_fix2: process.env.API_URI + 'configs/upload-fit-fix/1140/400/520/200',
        url_fit_fix3: process.env.API_URI + 'configs/upload-fit-fix/500/500/300/300',
        headers: {
          Authorization: ''
        }
      }
    }
  },
  computed: {
    ...mapGetters('account', ['accountInfo'])
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModelHomeMenu()
    this.configUpload()
  },
  methods: {
    handleImageAdded: async function (file, success, failure) {
      // images_upload_handler: handleImageAdded // Vứt vào đoạn option cạnh chữ 500px
      let formData = new FormData()
      formData.append('file', file.blob())
      let response = await axios.post('configs/upload-not-resize', formData)
      if (response.code === 1) {
        success(response.data.path)
      } else {
        return false
      }
    },
    getImage (data) {
      return process.env.IMAGE_S3_URL + 'storage/images/configs/' + data
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'configs-home', text: 'Config Home' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Cấu hình Upload
    configUpload () {
      const token = ls.get('authen', '')
      if (token) {
        this.upload.headers.Authorization = `Bearer ${token.access_token}`
      } else {
        this.upload.headers.Authorization = 'Bearer'
      }
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'home-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModelHomeMenu () {
      this.canSubmit = false
      axios.get('configs/home-banner').then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.modelData = response.data.value
            this.modelData_ID = response.data.id
            this.logModel.logs = response.data.logs
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    updateModelHomeMenu (formName) {
      this.canSubmit = false
      let data = {
        'value': this.modelData
      }
      axios.put('configs/' + this.modelData_ID, data).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },

    addImage1 () {
      this.modelData.list_banner.push({
        'key': Math.floor(Math.random() * 100000) + 1,
        'text': '',
        'image': '',
        'note': '',
        'link': '',
        'priority': 0
      })
    },
    removeImage1 (item) {
      var index = this.modelData.list_banner.indexOf(item)
      if (index !== -1) {
        this.modelData.list_banner.splice(index, 1)
      }
    },

    addImage2 () {
      this.modelData.list_partner.push({
        'key': Math.floor(Math.random() * 100000) + 1,
        'image': '',
        'link': '',
        'priority': 0
      })
    },
    removeImage2 (item) {
      var index = this.modelData.list_partner.indexOf(item)
      if (index !== -1) {
        this.modelData.list_partner.splice(index, 1)
      }
    },

    addImage3 () {
      this.modelData.list_resources.push({
        'key': Math.floor(Math.random() * 100000) + 1,
        'image': '',
        'link': '',
        'title_1': '',
        'color_1': '#34E311',
        'title_2': '',
        'priority': 0
      })
    },
    removeImage3 (item) {
      var index = this.modelData.list_resources.indexOf(item)
      if (index !== -1) {
        this.modelData.list_resources.splice(index, 1)
      }
    },

    // Upload Ảnh
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('Ảnh trường có dung lượng ảnh tối đa là 2M')
      }
      return isLt2M
    },
    handleAvatarSuccess (response) {
      this.upload.uploadProcess = false
      if (response.code) {
        this.image = response.data.name
        this.image_path = response.data.path_sm
      }
    },
    handleAvatarProcess (event, file, fileList) {
      this.upload.uploadProcess = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
.huhu {
  margin-top: 10px;
}
.line {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 10px;
}
.line input {
  margin-right: 10px;
}
.image-preview {
  height: 50px;
  width: 50px;
  margin-right: 10px;
}
</style>
<style type="text/css">
.updatSeting .course-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
}
.course-uploader .el-upload:hover {
  border-color: #409EFF;
}
.updatSeting .course-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 180px;
  height: 100px;
  line-height: 100px !important;
  text-align: center;
}

.updatSeting .courseSettig {
  width: 100px;
  height: 100px;
}

.log-class-user .item {
  margin-bottom: 10px;
}
.log-class-user .time {
  color: #7d7d7d;
}
</style>



// WEBPACK FOOTER //
// src/components/config-home/Update4.vue